import { Box, Grid, InputBase } from '@mui/material';
import { SearchIcon } from '@react-pdf-viewer/search';
import { isEmpty } from 'lodash-es';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { ClientDTO } from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import WsCheckBox from '../../../components/WsCheckBox/WsCheckBox';
import { StyledFooter } from '../../../features/jobs/assign/types';
import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { IClientCheckBoxListOptions } from '../helper/ClientSettingsHelper';

import ClientSpocs from './ClientsAndSpocsCheckbox';
interface IClientList {
  unselectedClients: ClientDTO[];
  onInput?: (data: FieldValues) => void;
}

const ClientList = ({ unselectedClients, onInput }: IClientList) => {
  const methods = useForm();
  const { watch, setValue, reset, handleSubmit } = methods;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [filteredClientsData, setFilteredClientsData] = useState<ClientDTO[]>([]);
  const selectedclients = watch('clientList');
  useEffect(() => {
    setFilteredClientsData(unselectedClients);
  }, [unselectedClients]);

  const clientsOptions: IClientCheckBoxListOptions = useMemo(() => {
    const temp: IClientCheckBoxListOptions = {};
    filteredClientsData?.forEach((client) => {
      if (client?.id) {
        temp[client.id] = {
          id: client?.id,
          name: client?.name ?? 'NA',
          status: client?.clientStatus?.isMarkInactive ? 'Inactive' : 'Active', // Provide default status if not available
        };
      }
    });
    return temp;
  }, [filteredClientsData]);

  const handleSelectEvents = (checked: boolean) =>
    setValue('clientList', checked ? Object.keys(clientsOptions) : []);

  const saveName = (data) => {
    if (data?.clientList?.length > 0) {
      onInput && onInput(data);
      reset();
    } else {
      setNotification(warning('Please select atleast one Client'));
    }
  };
  const onTeamsInput = useCallback(
    ({ target: { value } }) => {
      if (!isEmpty(value)) {
        const lowercasedValue = value.toLowerCase();
        const filteredRows =
          unselectedClients?.filter((row) => row?.name?.toLowerCase().includes(lowercasedValue)) ??
          [];
        setFilteredClientsData(filteredRows);
      } else {
        setFilteredClientsData(unselectedClients);
      }
    },
    [unselectedClients]
  );
  return (
    <Box>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(saveName)}>
          <Grid container alignItems="center" pl={2} spacing={1}>
            <Grid item>
              <SearchIcon />
            </Grid>
            <Grid item>
              <InputBase placeholder="search" name="searchtext" onChange={onTeamsInput} fullWidth />
            </Grid>
          </Grid>
          <Grid spacing={1}>
            <Grid container pl={2}>
              <WsCheckBox
                name="selectAll"
                label="Select All Clients"
                bold={true}
                onClick={handleSelectEvents}
              />
            </Grid>
            <Grid container pl={2} pb={8.5}>
              <ClientSpocs name="clientList" clientsOptions={clientsOptions} />
            </Grid>
          </Grid>
          <StyledFooter>
            <Grid container item justifyContent="space-between" py={1}>
              <WsButton variant="text" size="large">
                {`${selectedclients?.length ?? 0} Selected`}
              </WsButton>
              <Grid item mr={1.5}>
                <WsButton size="large" variant="contained" type="submit">
                  Save
                </WsButton>
              </Grid>
            </Grid>
          </StyledFooter>
        </form>
      </FormProvider>
    </Box>
  );
};
export default ClientList;
